const styles = `:host {
  display: inline-flex;
  flex-direction: column;
}
:host .root {
  border-width: 1px;
  border-style: solid;
  border-color: var(--goto-border);
  color: var(--goto-text-01);
  font: var(--goto-body-medium);
  height: 36px;
  border-radius: 4px;
  padding: 0 12px;
  box-sizing: border-box;
  background-color: var(--goto-ui-01);
  outline: 0;
  display: inline-flex;
}
:host .root:hover {
  border-color: var(--goto-border);
}
:host ::slotted([slot=helpertext]) {
  color: var(--goto-text-02);
  margin-top: var(--goto-spacing-01);
  font: var(--goto-caption-default-01);
}
:host input {
  background: none;
  border: none;
  box-shadow: none;
  font: inherit;
  outline: 0;
  width: 100%;
  color: var(--goto-text-01);
}
:host input::placeholder {
  color: var(--goto-text-02);
  font: var(--goto-body-medium);
  margin-top: var(--goto-spacing-01);
  display: inline-flex;
  opacity: 1;
  line-height: 1.3rem;
}

:host(:focus-within) .root {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight-small);
}

:host(:focus-visible) {
  outline: none;
}

.start,
.end {
  align-items: center;
  display: inline-flex;
}

::slotted([slot=end]):not(chameleon-icon-button),
::slotted([slot=start]):not(chameleon-icon-button) {
  color: var(--goto-overlay-01);
  --goto-icon-size: 14px;
  --goto-icon-color: var(--goto-overlay-01);
  font: var(--goto-body-medium);
}

::slotted([slot=start]) {
  margin-right: 6px;
}

::slotted([slot=end]) {
  margin-left: 6px;
}

::slotted(svg[slot=end]),
::slotted(svg[slot=start]) {
  height: 14px;
  width: 14px;
}

:host([success]) .root {
  border-color: var(--goto-input-success-border);
}
:host([success]) ::slotted([slot=end]) {
  --goto-icon-color: var(--goto-success-01);
  color: var(--goto-success-01);
}
:host([success]) ::slotted([slot=helpertext]) {
  color: var(--goto-success-01);
}

:host([success]:focus-within) .root {
  border-color: var(--goto-input-success-border);
  box-shadow: var(--goto-highlight-success-small);
}

:host([disabled]) .root {
  border-color: var(--goto-border);
  background-color: var(--goto-field-04);
  box-shadow: none;
  cursor: default;
  color: var(--goto-text-03);
}
:host([disabled]) .label {
  color: var(--goto-text-03);
}
:host([disabled]) input {
  color: var(--goto-text-03);
}
:host([disabled]) input:focus-visible {
  border-color: var(--goto-border);
  background-color: var(--goto-field-04);
  box-shadow: none;
  cursor: default;
  color: var(--goto-text-03);
}
:host([disabled]) input:-moz-focusring {
  border-color: var(--goto-border);
  background-color: var(--goto-field-04);
  box-shadow: none;
  cursor: default;
  color: var(--goto-text-03);
}
:host([disabled]) input::placeholder {
  color: var(--goto-text-03);
}
:host([disabled]) ::slotted([slot=helpertext]) {
  color: var(--goto-text-03);
}

:host([readonly]) .root {
  border-color: var(--goto-border);
  background-color: var(--goto-field-04);
  box-shadow: none;
  color: var(--goto-text-01);
}
:host([readonly]) .root input::placeholder {
  color: var(--goto-text-01);
}

:host([readonly]:focus-within) .root {
  border-color: var(--goto-border);
  background-color: var(--goto-field-04);
  box-shadow: none;
  color: var(--goto-text-01);
}

:host([error]) .root {
  border-color: var(--goto-input-danger-border);
}
:host([error]) ::slotted([slot=end]) {
  --goto-icon-color: var(--goto-danger-01);
  color: var(--goto-danger-01);
}
:host([error]) ::slotted([slot=helpertext]) {
  color: var(--goto-danger-01);
}

:host([error]:focus-within) .root {
  border-color: var(--goto-input-danger-border);
  box-shadow: var(--goto-highlight-error-small);
}

:host([fieldsize=small]) .root {
  font: var(--goto-body-small);
  height: 30px;
}
:host([fieldsize=small]) .root input::placeholder {
  font: var(--goto-body-small);
}
:host([fieldsize=small]) ::slotted([slot=end]),
:host([fieldsize=small]) ::slotted([slot=start]) {
  font: var(--goto-body-small);
}

:host([fieldsize=large]) .root {
  height: 42px;
}

:host([fieldsize=xlarge]) .root {
  height: 48px;
}

.label {
  color: var(--goto-text-01);
  font: var(--goto-caption-default-02);
  display: inline-flex;
  margin-bottom: 2px;
}

:host([fullwidth]) {
  width: 100%;
}
:host([fullwidth]) .control {
  width: 100%;
}`; export default styles;